<template id="recherche">
    <div class="recherche-container">
        <div class="flex-container">
            <div class="form-group input-group tx-solr-search-form" id="tx-solr-search-form-pi-results">
                <label class="label-invisible" for="recherche_par_ville">Municipalité</label>
                <input style="position: relative;" class="tx-solr-q js-solr-q tx-solr-suggest tx-solr-suggest-focus form-control" role="search" aria-label="Recherche d'une municipalité" autocomplete="off" id="recherche_par_ville" type="text" @keyup.enter="onClickEnter"/>
                <button @click="onClickResetMunicipalite" type="button" aria-label="Bouton pour effacer le champ Municipalité" class="btn_reset_input_inside"><span>x</span></button>
            </div>
            <div class="form-group input-group tx-solr-search-form" id="tx-solr-search-form-pi-results2">
                <label class="label-invisible" for="recherche_par_etablissement">Nom de l'établissement</label>
                <input style="position: relative;" class="tx-solr-q js-solr-q tx-solr-suggest tx-solr-suggest-focus form-control" role="search" aria-label="Recherche d'un établissement" autocomplete="off" id="recherche_par_etablissement" type="text" @keyup.enter="onClickEnter"/>
                <button @click="onClickResetEtablissement" type="button" aria-label="Bouton pour effacer le champ Nom d'établissement" class="btn_reset_input_inside"><span>x</span></button>
            </div>
        </div>
        <span class="input-group-btn">
            <button  aria-label="Bouton pour filtrer par établissement et ou ville inscrite dans le champs de recherche établissement et ville" type="button" class="btn btn-primary" @click="onClickRecherche"><span class="glyphicon glyphicon-search"></span><span>Rechercher</span></button>
        </span>
    </div>
</template>

<script>
    export default{
        name:"RechercheCond",
        components: {
    
        },
        emits: ['filtreRecherche'],
        props: {
    
        },
        methods:{
            onClickRecherche(){
                let rechercheVille=document.getElementById('recherche_par_ville').value;
                let rechercheEtablissement=document.getElementById('recherche_par_etablissement').value;
                this.$emit('filtreRecherche',rechercheVille,rechercheEtablissement);
            },
            onClickEnter(){
                this.onClickRecherche()
            },
            onClickResetMunicipalite(){
                document.querySelector('#recherche_par_ville').value = '';
            },
            onClickResetEtablissement(){
                document.querySelector('#recherche_par_etablissement').value = '';
            }
        },
        computed: {
    
        }
    }
</script>